package com.ijoin.data.api

import io.ktor.http.HttpStatusCode

/**
 * Generic exception used to propagate HTTP failures from the API layer.
 */
class ApiException(
    val status: HttpStatusCode,
    message: String
) : Exception(message)
